//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ID from '@/listing-app/mixins/ID'
import Theme from '@/listing-app/mixins/Theme'
export default {
	name: "Tooltip",
	mixins: [Theme, ID],
	props: ["text", "title", "tip_open"],
  data() {
    return {
      open: false,
      toggled: false
    }
  },
  methods: {
    toggle() {
      this.$emit("tooltipToggle", 'toggle')
    },
    close() {
      this.$emit("tooltipToggle", 'close')
    }
  }
}
